import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const reviewTypeApi = generateNomenApi(`/nomen/review-type`);

export const reviewTypeOptions = generateNomenOptions('review-type', reviewTypeApi);
